import React from "react"
import {
  cls3,
  cls4,
  cls5,
  cls6,
  cls7,
  cls8,
  cls9,
  cls10,
  cls11,
  cls12,
  cls13,
  cls14,
  cls15,
  cls16,
  cls17,
  cls18,
  cls19,
} from "./Modernise.module.scss"
//</style><pattern id="New_Pattern_2" data-name="New Pattern 2" width="16" height="19" patternTransform="translate(-93.9 -31) scale(0.96)" patternUnits="userSpaceOnUse" viewBox="0 0 16 19"><rect class={cls1} width="16" height="19"/><polygon class={cls2} points="16 22.18 10.5 19 16 15.82 21.5 19 16 22.18"/><polygon class={cls2} points="0 22.18 -5.5 19 0 15.82 5.5 19 0 22.18"/><polygon class={cls2} points="8 12.68 2.5 9.5 8 6.33 13.5 9.5 8 12.68"/><polygon class={cls2} points="16 3.18 10.5 0 16 -3.17 21.5 0 16 3.18"/><polygon class={cls2} points="0 3.18 -5.5 0 0 -3.17 5.5 0 0 3.18"/></pattern></defs>

export const Modernise = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1402.02 1218.56">
      <g class={cls3}>
        <g id="Layer_2" data-name="Layer 2">
          <g id="shadow" class={cls4}>
            <path
              class={cls5}
              d="M515,823.92c-13.51-7.68-29.08-8.86-44.2-10.58a238.49,238.49,0,0,0-38-1.53c-26,1.21-52.76,7.1-74.84,21.41-12.67,8.21-26,19.07-30.31,34.21a38.45,38.45,0,0,0-1.41,7.94l-10.59,7.19q-25,16.92-49.94,33.85c-16.37,11.14-32.49,22.68-48.72,34-3.07,2.15-6.07,4.42-9.15,6.55-3.43-5.08-8.82-8.62-15.38-8.49-16.75.34-26.39,16.74-23.09,32.12,2.39,11.09,11.09,20.64,21.36,25,21.55,9.09,41.69-4.48,59.23-15.79q45.45-29.28,90.37-59.35l7.37-4.91c8.89,6,19.21,9,29.57,11.28,27.67,6.23,55.8,9.26,83.85,3.66,22-4.4,44.55-16,59.22-33.21,10-11.77,19.28-26.44,19.29-42.47C539.68,847.63,529.8,832.32,515,823.92ZM211.39,965.19l.16.43Q212.41,973.09,211.39,965.19ZM482.73,872l-.05,0a6.89,6.89,0,0,1,1.75-2.65A23.59,23.59,0,0,0,482.73,872Zm-6.65,6.58a23,23,0,0,0-2.66,1.8c0-.21.73-.86,2.72-1.85ZM140,783.35c-2.14,10.41-8.87,18.69-17.34,24.74-10.57,7.56-24.75,9.7-37.47,9.16-8.36-.35-16.7-1.68-24.27-4.77a54.9,54.9,0,0,1-7.15-2.66A38.55,38.55,0,0,1,37.45,795.6C33.74,789.74,32.83,783,33,776.23a15.73,15.73,0,0,1,4.62-10.77A43.09,43.09,0,0,1,46.28,750c12.24-14,31.19-16.48,48.56-13.2a54.75,54.75,0,0,1,16.49,5.86,38.33,38.33,0,0,1,14.34,5.81C137.25,756.49,142.86,769.38,140,783.35ZM505.73,580.68c-9.3.22-21.77.69-29.58-5.09-5.17-3.82-8.76-8.51-8.76-15.27,0-5.82,3.27-12.65,8.76-15.26,9.38-4.48,19.47-3.36,29.58-3.78,11-.47,19.24,9.4,19.7,19.7C525.91,571.8,516,580.44,505.73,580.68Zm654.05,4.68c-6.5-6.11-15.89-9.8-23.68-14-12.28-6.66-24.56-13.34-36.9-19.91-25.14-13.39-50-28-75.84-39.93-7.85-3.63-16-8.43-24.43-10.56-11.06-2.8-20.81,0-30.1,6-6.62,4.31-13.49,8.28-20,12.74-4.16,2.84-10,7-12.62,11.51-3.15,5.39-3.78,13.83,1.3,18.37,10.65,9.53,24.54,2,35.49-3,3.83-1.74,7.63-3.55,11.48-5.25,10.25,7.36,21.3,13.69,32.39,19.81-2.93-.61-5.89-1.13-8.89-1.53-21.27-2.86-48.73-1.16-56.59,23.07-3.3,10.19-1,20.62.88,30.86q2.24,12.3,5.29,24.44a376.94,376.94,0,0,0,16.11,49.15,31.35,31.35,0,0,0,9.45,13.15c0,.26,0,.53.06.79,1.08,8,8.73,16.54,17.59,15.52,8.2-.94,16.46-1.33,24.55-3q10.49-2.19,20.8-5.11a328.11,328.11,0,0,0,44.41-16.44c13.5-6,27.3-12.74,38.56-22.49,9.94-8.6,15.42-21.93,14-34.66,6.59-2.31,12.82-5,18-10.26C1171.86,613.56,1170.85,595.76,1159.78,585.36Zm-27.42,1.55c-.49-.21-2.55.65-3.95,1.23C1129.8,587,1131.18,586.39,1132.36,586.91ZM994.78,1158.05c-10,.67-20.47-.4-30.55-.69l-17.43-.5a16.31,16.31,0,0,1,.45,5.79l-.07.64c-1.09,10.61-6.42,19.27-17.15,22.54-5.85,1.78-12.58,1.24-18.66,1.24q-6.64,0-13.28-.1c-3.76-.06-7.52-.13-11.28-.23a24.22,24.22,0,0,1,.83,9.74c-1.59,11.84-11.3,19.73-23,20.31-8.55.42-17.29-.55-25.88-.48-8,.06-16,.53-24,1s-15.79,1.15-23.74,1.28c-5.14.09-10.91,0-15.82-1.6a23.06,23.06,0,0,1-11.43-7.49l.13.23a22.55,22.55,0,0,1-5.21-5.72,26.75,26.75,0,0,1-2.07-4.6c.54,1.44.56,1.67.08.69-1.86-1-2.29-6.57-2.26-8.39a12.38,12.38,0,0,1,4-9.21c4.86-4,9.69-3.8,14.71-1.74,2.37-.54,4.84-.78,7.21-1.27,3.53-.73,7-1.89,10.41-2.92,8.6-2.56,17.76-3.78,26.68-4.84A17.13,17.13,0,0,1,813,1160c0-16.09,19.59-20.13,32-20,7.31.11,14.62,0,21.93,0-3-6.4-1.95-13.29,3.1-19.31,8.4-10,25-9.53,36.91-10.14,9.55-.48,19.09-1,28.65-1.26l28.64-.7c10.08-.24,20.5-1.27,30.55-.56,6.41-.81,13.15,3.16,17.67,7.32,4.91,4.5,7,11.2,7.32,17.67C1020.4,1147.18,1007.8,1157.19,994.78,1158.05Zm210.81-50a66.61,66.61,0,0,1-20.6,10.34,55.52,55.52,0,0,1-13.43,2,29.47,29.47,0,0,1-11.35,3.28c-14.94,1.15-29.87-7.61-34-22.49-4.42-16,5.41-29.94,19.7-36,18-7.58,39.16-8.1,56.83.57a25.94,25.94,0,0,1,13.37,16.13C1219,1092.24,1213.89,1102.06,1205.59,1108ZM1176.8,409.53c-7.94-3.35-17.15-4.33-25.76-4.13-9.45.23-20.19,2-28.58,6.67a33.63,33.63,0,0,0-12.61,12,26,26,0,0,0-3.21,8.73c-2,2.78-2.49,6.17-1.91,10a15.7,15.7,0,0,0,3.28,7.3c3.59,8.42,14.16,15.09,22.85,14.53l1.07-.07a28.67,28.67,0,0,0,6.73-1.27c1.71.25,3.43.48,5.15.67,7,.73,14.6-.58,21.34-2.4,9.48-2.55,18.89-6.94,24.12-15.68C1197.31,432.45,1190.73,415.41,1176.8,409.53Zm123.42-17.44c-8.59-.25-18.07-.73-25.59-5.39a19.44,19.44,0,0,1,0-33.18c7.53-4.67,17-5.14,25.59-5.39,12.31-.36,21.46,10.36,22,22S1311.72,392.43,1300.22,392.09Zm13.65,541.81c-2.35,10.32-14,16.07-23.84,13.54,5.93,1.53-1.34,0-2.82-.15-2.86-.26-5.72-.49-8.55-1-4.9-.88-9.34-2.3-13.39-5.31-9.2-6.86-10.2-19.47,0-26.15,9.8-6.42,23.79-6.36,35.06-4.76C1311.07,911.59,1316,924.75,1313.87,933.9ZM889.38,765.6c-2.35,10.31-14,16.06-23.83,13.53,5.92,1.53-1.35,0-2.82-.15-2.86-.26-5.72-.49-8.55-1-4.9-.88-9.35-2.29-13.4-5.31-9.2-6.85-10.19-19.47,0-26.14,9.81-6.42,23.8-6.37,35.07-4.77C886.58,743.28,891.46,756.45,889.38,765.6Zm-449.1,319.57c-9.56,1.49-24.2,4.47-32.57-1.64-9.6-7-11.06-17.91-3.49-27.14,6.5-7.94,21.29-8.84,30.84-9.79,9.74-1,18.09,8.17,19.28,17C455.51,1072.31,449.89,1083.67,440.28,1085.17Zm68.15-684.88c-15.13,9.77-30.42,19.29-45.72,28.8q-40.05,24.9-81.15,48.09-20.76,11.67-41.75,22.9c-7,3.73-13.93,7.66-21.06,11.11-3.86,1.88-7.86,3.5-11.79,5.21-5.78,2.53-11.34,5.42-17.84,5.16-15.08-.59-27.65-17.88-18.28-31.87,6.26-9.35,17.86-15.1,27.75-20.24q11.78-6.13,23.49-12.4c55.72-29.82,110.31-61.75,163.26-96.25,10.73-7,24.85-1.8,31.3,8.2C523.53,379.7,518.47,393.81,508.43,400.29ZM934.32,915.54a58.85,58.85,0,0,0,.72-9c0-36.26-38.9-42.46-78.38-42.46-20.49,0-41.15,1.67-56.59,1.67-38,0-37.18-25.52-61.1-25.52a31.4,31.4,0,0,0-8.5,1.25c-33.18,13-63.71,33.53-87.51,59.68-1.61-5.37-5.6-10.12-11.3-11.42-7.57-1.73-14.17,1.34-18.57,7.56-17.58,24.82.49,56.08,23.2,70,10.88,6.69,23.94,10.07,36.45,12.07,13.72,2.19,27.55,3.41,41.4,4.35a614.83,614.83,0,0,0,77.62.82q19.85-1.17,39.59-3.62c12.63-1.57,25.38-3.13,37.69-6.47,27.09-7.37,54.35-23.86,63.5-51.9A53.16,53.16,0,0,0,934.32,915.54Z"
            />
          </g>
          <g id="lineart">
            <polyline
              class={cls6}
              points="169.78 319.68 151.56 337.63 133.34 298.63 115.12 316.59 96.9 277.59 78.67 295.55"
            />
            <path
              class={cls7}
              d="M1092.28,604.63v53.55c0,3.22-2.13,6.44-6.37,8.89l-69.29,40c-8.5,4.91-22.3,4.91-30.81,0L835.56,620.33c-4.25-2.46-6.37-5.68-6.37-8.89V557.68c0,3.22,2.12,6.44,6.37,8.89l150.25,86.75c8.51,4.91,22.31,4.91,30.81,0l69.29-40C1090.08,610.92,1092.2,607.77,1092.28,604.63ZM980.49,677.37a7,7,0,0,0-3.19-5.53c-1.75-1-3.18-.2-3.18,1.84a7.07,7.07,0,0,0,3.18,5.52C979.07,680.22,980.49,679.4,980.49,677.37ZM969,670.74a7,7,0,0,0-3.18-5.52c-1.76-1-3.18-.2-3.18,1.83a7,7,0,0,0,3.18,5.53C967.59,673.6,969,672.77,969,670.74Zm-11.47-6.63a7,7,0,0,0-3.19-5.52c-1.76-1-3.19-.19-3.19,1.84a7,7,0,0,0,3.19,5.52C956.12,667,957.54,666.14,957.54,664.11Z"
            />
            <path
              class={cls7}
              d="M1085.91,595.53a17.25,17.25,0,0,1,3.36,2.49,8.91,8.91,0,0,1,3,6.41v.2c-.08,3.14-2.2,6.29-6.37,8.68l-69.29,40c-8.5,4.91-22.3,4.91-30.81,0L835.56,566.57c-4.25-2.45-6.37-5.67-6.37-8.89s2.12-6.43,6.37-8.89L890,517.36v15.79l-27.3,15.76a4.67,4.67,0,0,0,0,8.1L890,572.76l105.62,61a17.52,17.52,0,0,0,13.68,0l17.87-10.32,9.61-5.55,25-14.44a4.32,4.32,0,0,0,0-7.48l-25-14.46V567.18Z"
            />
            <path
              class={cls8}
              d="M1061.83,596a4.32,4.32,0,0,1,0,7.48l-25,14.44V581.5Z"
            />
            <path
              class={cls9}
              d="M1027.19,560.67v62.76l-17.87,10.32a17.52,17.52,0,0,1-13.68,0L890,572.76V526.82c4.05-9.25,7.62-20.3,15.49-15.76,14.1,8.15,10.85,34,28,43.91s14.12-35.59,28.23-27.44,10.66,31.23,28.22,41.35,14.1-38.3,28.23-30.15C1022.73,541.4,1025.23,550,1027.19,560.67Z"
            />
            <path
              class={cls7}
              d="M1027.19,520.78v39.89c-2-10.72-4.46-19.27-9.05-21.94-14.13-8.15-10.67,40.29-28.23,30.15s-14.12-33.2-28.22-41.35S950.57,564.84,933.46,555s-13.85-35.76-28-43.91c-7.87-4.54-11.44,6.51-15.49,15.76V441.6c0-2.6.86-4.45,2.23-5.23l.12-.06a4.17,4.17,0,0,1,4.12.4l124.24,71.72C1024.29,510.5,1027.19,516,1027.19,520.78Z"
            />
            <path
              class={cls7}
              d="M977.3,671.84a7,7,0,0,1,3.19,5.53c0,2-1.42,2.85-3.19,1.83a7.07,7.07,0,0,1-3.18-5.52C974.12,671.64,975.55,670.83,977.3,671.84Z"
            />
            <path
              class={cls7}
              d="M965.83,665.22a7,7,0,0,1,3.18,5.52c0,2-1.42,2.86-3.18,1.84a7,7,0,0,1-3.18-5.53C962.65,665,964.07,664.2,965.83,665.22Z"
            />
            <path
              class={cls7}
              d="M954.35,658.59a7,7,0,0,1,3.19,5.52c0,2-1.42,2.86-3.19,1.84a7,7,0,0,1-3.19-5.52C951.16,658.4,952.59,657.57,954.35,658.59Z"
            />
            <path
              class={cls7}
              d="M896.49,436.71a4.17,4.17,0,0,0-4.12-.4l9.51-5.5a4.1,4.1,0,0,1,4.21.35l124.25,71.73c3.57,2.05,6.46,7.59,6.46,12.34V617.88l-9.61,5.55V520.78c0-4.75-2.9-10.28-6.46-12.35Z"
            />
            <path
              class={cls8}
              d="M890,533.15v39.61L862.72,557a4.67,4.67,0,0,1,0-8.1Z"
            />
            <path
              class={cls6}
              d="M1085.91,613.31l-69.29,40c-8.5,4.91-22.3,4.91-30.81,0L835.56,566.57c-4.25-2.45-6.37-5.67-6.37-8.89s2.12-6.43,6.37-8.89L890,517.36"
            />
            <path
              class={cls6}
              d="M1036.8,567.18l49.11,28.35a17.25,17.25,0,0,1,3.36,2.49,8.91,8.91,0,0,1,3,6.41v53.75c0,3.22-2.13,6.44-6.37,8.89l-69.29,40c-8.5,4.91-22.3,4.91-30.81,0L835.56,620.33c-4.25-2.46-6.37-5.68-6.37-8.89V557.68"
            />
            <path
              class={cls6}
              d="M1085.91,613.31c4.17-2.39,6.29-5.54,6.37-8.68"
            />
            <path
              class={cls6}
              d="M892.37,436.31a4.17,4.17,0,0,1,4.12.4l124.24,71.72c3.56,2.07,6.46,7.6,6.46,12.35V623.43"
            />
            <path
              class={cls6}
              d="M1036.8,617.88V515.23c0-4.75-2.89-10.29-6.46-12.34L906.09,431.16a4.1,4.1,0,0,0-4.21-.35l-9.51,5.5-.12.06c-1.37.78-2.23,2.63-2.23,5.23V572.76"
            />
            <path
              class={cls6}
              d="M890,526.82c4.05-9.25,7.62-20.3,15.49-15.76,14.1,8.15,10.85,34,28,43.91s14.12-35.59,28.23-27.44,10.66,31.23,28.22,41.35,14.1-38.3,28.23-30.15c4.59,2.67,7.09,11.22,9.05,21.94"
            />
            <path
              class={cls6}
              d="M948.88,659.11c0,2-1.42,2.86-3.19,1.84a7,7,0,0,1-3.19-5.52c0-2,1.43-2.86,3.19-1.84A7,7,0,0,1,948.88,659.11Z"
            />
            <path
              class={cls6}
              d="M964.68,668.24c0,2-1.42,2.86-3.18,1.84a7,7,0,0,1-3.18-5.53c0-2,1.42-2.85,3.18-1.83A7,7,0,0,1,964.68,668.24Z"
            />
            <path
              class={cls6}
              d="M980.49,677.37c0,2-1.42,2.85-3.19,1.83a7.07,7.07,0,0,1-3.18-5.52c0-2,1.43-2.85,3.18-1.84A7,7,0,0,1,980.49,677.37Z"
            />
            <path
              class={cls6}
              d="M1036.8,581.5l25,14.46a4.32,4.32,0,0,1,0,7.48l-25,14.44-9.61,5.55-17.87,10.32a17.52,17.52,0,0,1-13.68,0L890,572.76,862.72,557a4.67,4.67,0,0,1,0-8.1L890,533.15"
            />
            <path
              class={cls7}
              d="M500.82,157.6V303.86c0,9.68-6.8,21.45-15.19,26.28l-34.62,20L424.9,365.21,405,376.67,384,443.2,362.87,401l-80.6,46.56c-4.18,2.42-8,2.64-10.72,1.05l-.23-.12c-2.63-1.62-4.24-5-4.24-9.71V292.52c0-9.68,6.82-21.44,15.19-26.29l203.36-117.4c4.21-2.43,8-2.67,10.74-1.05S500.82,152.76,500.82,157.6Zm-44.69,76.15V221.62l-48.54,28v12.13l17.82-10.29v52.18l12.89-7.43V244ZM405,283.32q0-9.46-4-14.75a13.75,13.75,0,0,0-10.89-5.6q-6.93-.33-15.6,4.69A57.9,57.9,0,0,0,358.86,281,67,67,0,0,0,348,299.19,52,52,0,0,0,344,318.51q0,9.47,3.94,14.77a13.6,13.6,0,0,0,10.91,5.6q6.94.3,15.63-4.71a58.24,58.24,0,0,0,15.6-13.32A67.77,67.77,0,0,0,401,302.66,51.38,51.38,0,0,0,405,283.32Zm-70.65,72.95V292l-12.89,7.45v64.31Z"
            />
            <path
              class={cls9}
              d="M477.29,136.74l19.08,11c-2.73-1.62-6.53-1.38-10.74,1.05L282.27,266.23c-8.37,4.85-15.19,16.61-15.19,26.29V438.78c0,4.72,1.61,8.09,4.24,9.71L252.44,437.6c-2.73-1.58-4.43-5-4.43-9.85V281.49c0-9.68,6.79-21.43,15.18-26.28l203.36-117.4C470.75,135.37,474.55,135.15,477.29,136.74Z"
            />
            <polygon
              class={cls8}
              points="456.13 221.62 456.13 233.75 438.3 244.04 438.3 296.23 425.41 303.66 425.41 251.48 407.58 261.77 407.58 249.64 456.13 221.62"
            />
            <path
              class={cls8}
              d="M401,268.57q4,5.28,4,14.75a51.38,51.38,0,0,1-4,19.34,67.77,67.77,0,0,1-10.89,18.19,58.24,58.24,0,0,1-15.6,13.32q-8.69,5-15.63,4.71a13.6,13.6,0,0,1-10.91-5.6Q344,328,344,318.51A52,52,0,0,1,348,299.19,67,67,0,0,1,358.86,281a57.9,57.9,0,0,1,15.63-13.34q8.67-5,15.6-4.69A13.75,13.75,0,0,1,401,268.57Zm-9.06,22.28q0-6-2.27-9.35a8,8,0,0,0-6.25-3.7c-2.66-.21-5.62.63-8.91,2.53a32.14,32.14,0,0,0-8.91,7.77A39,39,0,0,0,359.33,299a33.59,33.59,0,0,0-2.26,12c0,4,.75,7.1,2.26,9.35a8,8,0,0,0,6.25,3.7q4,.32,8.91-2.53a32.25,32.25,0,0,0,8.91-7.76,39.52,39.52,0,0,0,6.25-10.91A33.7,33.7,0,0,0,391.92,290.85Z"
            />
            <path
              class={cls7}
              d="M389.65,281.5q2.27,3.38,2.27,9.35a33.7,33.7,0,0,1-2.27,12,39.52,39.52,0,0,1-6.25,10.91,32.25,32.25,0,0,1-8.91,7.76q-4.94,2.85-8.91,2.53a8,8,0,0,1-6.25-3.7c-1.51-2.25-2.26-5.36-2.26-9.35a33.59,33.59,0,0,1,2.26-12,39,39,0,0,1,6.25-10.91,32.14,32.14,0,0,1,8.91-7.77c3.29-1.9,6.25-2.74,8.91-2.53A8,8,0,0,1,389.65,281.5Z"
            />
            <polygon
              class={cls8}
              points="334.31 291.95 334.31 356.27 321.42 363.71 321.42 299.4 334.31 291.95"
            />
            <path
              class={cls6}
              d="M271.55,448.61c2.75,1.59,6.54,1.37,10.72-1.05L362.87,401,384,443.2,405,376.67l19.89-11.46L451,350.12l34.62-20c8.39-4.83,15.19-16.6,15.19-26.28V157.6c0-4.84-1.7-8.25-4.45-9.82s-6.53-1.38-10.74,1.05L282.27,266.23c-8.37,4.85-15.19,16.61-15.19,26.29V438.78c0,4.72,1.61,8.09,4.24,9.71"
            />
            <path
              class={cls6}
              d="M271.55,448.61l-.23-.12L252.44,437.6c-2.73-1.58-4.43-5-4.43-9.85V281.49c0-9.68,6.79-21.43,15.18-26.28l203.36-117.4c4.2-2.44,8-2.66,10.74-1.07l19.08,11"
            />
            <polygon
              class={cls6}
              points="321.42 299.4 334.31 291.95 334.31 356.27 321.42 363.71 321.42 299.4"
            />
            <path
              class={cls6}
              d="M358.86,338.88a13.6,13.6,0,0,1-10.91-5.6Q344,328,344,318.51A52,52,0,0,1,348,299.19,67,67,0,0,1,358.86,281a57.9,57.9,0,0,1,15.63-13.34q8.67-5,15.6-4.69a13.75,13.75,0,0,1,10.89,5.6q4,5.28,4,14.75a51.38,51.38,0,0,1-4,19.34,67.77,67.77,0,0,1-10.89,18.19,58.24,58.24,0,0,1-15.6,13.32Q365.8,339.18,358.86,338.88Z"
            />
            <path
              class={cls6}
              d="M383.4,313.73a39.52,39.52,0,0,0,6.25-10.91,33.7,33.7,0,0,0,2.27-12q0-6-2.27-9.35a8,8,0,0,0-6.25-3.7c-2.66-.21-5.62.63-8.91,2.53a32.14,32.14,0,0,0-8.91,7.77A39,39,0,0,0,359.33,299a33.59,33.59,0,0,0-2.26,12c0,4,.75,7.1,2.26,9.35a8,8,0,0,0,6.25,3.7q4,.32,8.91-2.53A32.25,32.25,0,0,0,383.4,313.73Z"
            />
            <polygon
              class={cls6}
              points="425.41 251.48 407.58 261.77 407.58 249.64 456.13 221.62 456.13 233.75 438.3 244.04 438.3 296.23 425.41 303.66 425.41 251.48"
            />
            <g id="magnifying_glass" data-name="magnifying glass">
              <g id="magnifying_glass-2" data-name="magnifying glass">
                <path
                  class={cls8}
                  d="M186.41,940.19a22.73,22.73,0,1,0,30.23,33.9L318.6,876a18.73,18.73,0,0,0-28-22.15l-.22-.27-89.91,74.86Z"
                />
                <path
                  class={cls7}
                  d="M290.43,853.61l.22.27a18.73,18.73,0,0,1,28,22.15l8.11-7.79a20.21,20.21,0,0,0,1.82-2,17.27,17.27,0,0,0-24.82-23.67Z"
                />
                <path
                  class={cls9}
                  d="M303.13,806.75c0,2.11,0,4.19.17,6.22a88.57,88.57,0,0,0,5.2,26.76,17.25,17.25,0,0,1,22.71,10.89l3.13-.92A100,100,0,0,1,331,822.81c0-59.33,41.67-131.51,93.06-161.18,25.18-14.53,48-16.18,64.8-7.08L462,639.06c-16.84-9.72-40.1-8.33-65.79,6.52-12.95,7.46-25.27,17.62-36.48,29.61h0C326.43,710.79,303.13,762.35,303.13,806.75Z"
                />
                <path
                  class={cls9}
                  d="M328.53,866.21l1.57.62a2.92,2.92,0,0,0,.27.17L357,882.33c-10.54-6.55-18.43-17.64-22.62-32.63l-3.13.92A17.22,17.22,0,0,1,328.53,866.21Z"
                />
                <path
                  class={cls7}
                  d="M357.19,882.46c16.9,10.37,40.59,9.22,66.82-5.93,42-24.24,77.51-76.88,89.08-127.71a151.86,151.86,0,0,0,4-33.47c0-29.67-10.43-50.53-27.27-60.23l-.64-.37-.35-.2c-16.76-9.1-39.62-7.45-64.8,7.08C372.62,691.3,331,763.48,331,822.81a100,100,0,0,0,3.39,26.89c4.19,15,12.08,26.08,22.62,32.63Zm2.88-34.76c-6-8.81-9.49-21.05-9.49-36.22,0-46.84,32.88-103.77,73.43-127.18,13.15-7.58,25.48-10.72,36.15-9.86,22.25,1.7,37.27,20.62,37.27,52.25,0,46.83-32.88,103.77-73.42,127.17C396.58,869.71,372.67,866.16,360.07,847.7Z"
                />
                <path
                  class={cls7}
                  d="M350.58,811.48c0,15.17,3.45,27.41,9.49,36.22,12.6,18.46,36.51,22,63.94,6.16,40.54-23.4,73.42-80.34,73.42-127.17,0-31.63-15-50.55-37.27-52.25-10.67-.86-23,2.28-36.15,9.86C383.46,707.71,350.58,764.64,350.58,811.48Z"
                />
                <path
                  class={cls6}
                  d="M357.19,882.46c16.9,10.37,40.59,9.22,66.82-5.93,42-24.24,77.51-76.88,89.08-127.71a151.86,151.86,0,0,0,4-33.47c0-29.67-10.43-50.53-27.27-60.23"
                />
                <path
                  class={cls6}
                  d="M488.81,654.55c-16.76-9.1-39.62-7.45-64.8,7.08C372.62,691.3,331,763.48,331,822.81a100,100,0,0,0,3.39,26.89c4.19,15,12.08,26.08,22.62,32.63"
                />
                <path
                  class={cls6}
                  d="M460.16,674.44c-10.67-.86-23,2.28-36.15,9.86-40.55,23.41-73.43,80.34-73.43,127.18,0,15.17,3.45,27.41,9.49,36.22,12.6,18.46,36.51,22,63.94,6.16,40.54-23.4,73.42-80.34,73.42-127.17C497.43,695.06,482.41,676.14,460.16,674.44Z"
                />
                <path
                  class={cls6}
                  d="M489.8,655.12l-.64-.37-.35-.2L462,639.06c-16.84-9.72-40.1-8.33-65.79,6.52-12.95,7.46-25.27,17.62-36.48,29.61h0c-33.28,35.59-56.58,87.15-56.58,131.55,0,2.11,0,4.19.17,6.22a88.57,88.57,0,0,0,5.2,26.76"
                />
                <path
                  class={cls6}
                  d="M330.1,866.83a2.92,2.92,0,0,0,.27.17L357,882.33l.23.13,1,.59"
                />
                <path
                  class={cls6}
                  d="M318.6,876l-102,98.06a22.73,22.73,0,1,1-30.23-33.9l14.11-11.72,89.91-74.86,13.28-11.07a17.26,17.26,0,0,1,24.82,23.67,20.21,20.21,0,0,1-1.82,2Z"
                />
                <path
                  class={cls6}
                  d="M290.65,853.88a18.73,18.73,0,0,1,28,22.15"
                />
              </g>
            </g>
            <path
              class={cls8}
              d="M745.38,137.39c0,9,12.84,11.78,12.8,24.55-.07,16.44-19.17,36-19.24,53.68a23.15,23.15,0,0,0,2,9.55c-12.48-11.59-29.94-17-29.87-36.43-1.37-10.22-3.12-22.39-21.42-22.45-21.49-.09-44.41,19.47-61.4,19.41-15.91-.06-31.92-11.69-31.84-33.79,0-6.3,1.1-12.51,2.17-18.8,5.4-23.72,23-17.08,30.1-69.11,4.22-31.11,15.5-48.33,40.6-53.7C673.63,6.16,678.79,3,685.2,3c15.46.06,69,29.79,68.94,54.59,0,11.49-7.82,17.77-7.86,28.76,0,11.66,10.7,15.58,10.66,26.52C756.9,123.37,745.41,127.61,745.38,137.39Z"
            />
            <path
              class={cls6}
              d="M598.56,133.11c5.4-23.72,23-17.08,30.1-69.11,4.22-31.11,15.5-48.33,40.6-53.7C673.63,6.16,678.79,3,685.2,3c15.46.06,69,29.79,68.94,54.59,0,11.49-7.82,17.77-7.86,28.76,0,11.66,10.7,15.58,10.66,26.52,0,10.5-11.53,14.74-11.56,24.52,0,9,12.84,11.78,12.8,24.55-.07,16.44-19.17,36-19.24,53.68a23.15,23.15,0,0,0,2,9.55c-12.48-11.59-29.94-17-29.87-36.43-1.37-10.22-3.12-22.39-21.42-22.45-21.49-.09-44.41,19.47-61.4,19.41-15.91-.06-31.92-11.69-31.84-33.79C596.42,145.61,597.49,139.4,598.56,133.11Z"
            />
            <path
              class={cls9}
              d="M770.32,308.34c0-4,6.83-7.64,14.47-10.81a55.65,55.65,0,0,1-7.93.85c-2.1,0-4.6-.22-4.6-1.25,0-2.86,18.26-6.22,29.92-10.93l2.11-4.67c3.57,4.56,5.66,8.14,5.66,14.89,0,8.14-4.45,21.52-13.32,21.52a77,77,0,0,1-8.51-1.46c-2.75-.6-5.82-1.36-8.62-2.26h0c-4.34-1.39-8-3.09-9-5A2,2,0,0,1,770.32,308.34Z"
            />
            <path
              class={cls9}
              d="M693.05,112.77c5,8.35,8.47,17,8.47,24.88,0,13.11-6,25.19-20.5,25.19-19.4,0-29.12-15-61.84-31q3.8-2.33,7.69-4.52c4.2-2.29,9-4.82,14.2-7.32a17.53,17.53,0,0,0,8.82-9.5c4.59-12,6.36-22.13,8.23-31-5.18-2-7.47-5.29-7.47-8.39,0-4.47,4.73-8.66,12.38-8.66h.05c9-3.67,22.39-10.24,31.4-28.73,20.19,7.26,29,16.5,29,33.4,0,15.54-3.15,33.72-14.82,41.68a24.51,24.51,0,0,1-14.13,4.06C694.06,112.8,693.56,112.79,693.05,112.77Z"
            />
            <path
              class={cls8}
              d="M664.75,903.78a25.25,25.25,0,0,1-34.66,31.45A29.47,29.47,0,0,1,614.21,902q.84-3.57,1.57-7.2c5.24,10.13,13.52,18,23.05,18,7.27,0,17.76-6.71,23.56-15.65h0C663.16,899.35,664,901.58,664.75,903.78Z"
            />
            <path
              class={cls7}
              d="M776.86,298.38a55.65,55.65,0,0,0,7.93-.85c-7.64,3.17-14.47,6.84-14.47,10.81a2,2,0,0,0,.22.89c.91,1.9,4.61,3.6,9,5h0c2.8.9,5.87,1.66,8.62,2.26l-.28,1.49a14.44,14.44,0,0,1-6.61,6.93l-26.7,13.64-24.79,12.68a2.93,2.93,0,0,1-4-3.73l19.06-46.23,5-12,2.43-5.89,5.27-12.79,1.38-3.34a14.33,14.33,0,0,1,7.52-7.67l55-24a2,2,0,0,1,2.57,2.61l-19.58,43.37-2.11,4.67c-11.66,4.71-29.92,8.07-29.92,10.93C772.26,298.16,774.76,298.38,776.86,298.38Z"
            />
            <path
              class={cls9}
              d="M764.4,586.06h0c-7.09,69.28-18,141.68-23.3,177.1A140.53,140.53,0,0,0,740,795.88c2.14,25.15,8.69,52.53,24.26,71.23a73.25,73.25,0,0,1-6.46,5.93A16.64,16.64,0,0,1,736,872.3c-13.54-12.49-18.09-31-26.9-50-3.58-7.72-8.09-13-10.71-19.89a78.77,78.77,0,0,0,2.78-20.57c0-.77,0-1.55,0-2.33,0-34.66-7-79.93-7-109.31a216.75,216.75,0,0,1,4.69-46.56h0C722.9,615.51,746.85,600.85,764.4,586.06Z"
            />
            <path
              class={cls9}
              d="M722.62,301.09c-5.63,3.7-9.54,10-16,12.29-7.85,2.8-16.16,1.85-24,4.51-3.89-4.85-6.66-11-6.66-16.4a11.62,11.62,0,0,1,2.93-8.1l2.92-.09s27.45-4.1,46.77-13.9a12.09,12.09,0,0,1,8.5-.91c2.1.54,4,1.09,5.7,1.64,3.73,1.17,6.72,2.31,9.39,3.22l-2.43,5.89a44.3,44.3,0,0,1-6.53-.41,51.05,51.05,0,0,1-9.07-2c4.9,7.19,6,19.11,2.46,19s-4.58-10.46-9.65-14.87c1.47,5.07,4.57,17,.5,18A41.81,41.81,0,0,1,722.62,301.09Z"
            />
            <path
              class={cls8}
              d="M755.54,342.42c11.25,44.19,15.55,91.4,15.55,138.06,0,29.68-2.76,67.16-6.68,105.58h0c-17.55,14.79-41.5,29.45-65.54,37.54a119.61,119.61,0,0,1-27.71,6.08q-3.72.33-7.34.33a82.24,82.24,0,0,1-53.54-19.33c2.23-8.31,3.8-16.36,3.8-25.3,0-23.56-28-104.06-28-153.68,0-49.22,19-67.16,30.44-92.63,15.89-3.57,36-9.8,62.75-19.82a24.78,24.78,0,0,1,3.31-1.36c7.88-2.66,16.19-1.71,24-4.51,6.45-2.31,10.36-8.59,16-12.29a41.81,41.81,0,0,0,4.8,7.8c4.07-1,1-12.9-.5-18,5.07,4.41,6.05,14.7,9.65,14.87s2.44-11.76-2.46-19a51.05,51.05,0,0,0,9.07,2h0c.34,4.16.86,8.31,1.58,12.42L725.7,347.49a2.93,2.93,0,0,0,4,3.73l24.79-12.68C754.87,339.83,755.21,341.12,755.54,342.42Z"
            />
            <path
              class={cls9}
              d="M671.15,629.68h0a241.93,241.93,0,0,0-6.36,31.88c0,.09-14.43,176-14.43,176.14,0,17.49,5.15,39.24,12,59.4h0c-5.8,8.94-16.29,15.65-23.56,15.65-9.53,0-17.81-7.88-23.05-18a158.67,158.67,0,0,0,3.33-30.42c0-56.1-24.21-110.67-24.21-168.55,0-41.93,9.78-64.35,15.37-85.1A82.24,82.24,0,0,0,663.81,630Q667.43,630,671.15,629.68Z"
            />
            <path
              class={cls7}
              d="M600.08,295.69S602.41,279,604.89,258c8.69,11.19,16.35,22.44,18.78,37Z"
            />
            <path
              class={cls8}
              d="M764.22,867.11a64,64,0,0,0,13.34,12.15,6.79,6.79,0,0,1,2.58,8,7.06,7.06,0,0,1-4.56,4.18,47,47,0,0,1-14.42,2c-18.35,0-36.23-9.78-45.55-26.14a101.25,101.25,0,0,1-8.23-23.93c-3.13,7.34-4.51,16.34-5,24.5A7.4,7.4,0,0,1,701,868a9.91,9.91,0,0,1-3.45-.66c.09-3,.19-6,.19-9,0-13.4-3.11-24.63-3.11-36.67A42.68,42.68,0,0,1,697,806.88c.53-1.48,1-3,1.43-4.5,2.62,6.84,7.13,12.17,10.71,19.89,8.81,19,13.36,37.54,26.9,50a16.64,16.64,0,0,0,21.75.74A73.25,73.25,0,0,0,764.22,867.11Z"
            />
            <path
              class={cls7}
              d="M749.71,289.24l-5,12c-.72-4.11-1.24-8.26-1.58-12.42h0A44.3,44.3,0,0,0,749.71,289.24Z"
            />
            <path
              class={cls7}
              d="M623.67,295c-2.43-14.55-10.09-25.8-18.78-37-2.48,21-4.81,37.68-4.81,37.68Zm113.38-16.51a12.09,12.09,0,0,0-8.5.91c-19.32,9.8-46.77,13.9-46.77,13.9l-2.92.09a11.62,11.62,0,0,0-2.93,8.1c0,5.41,2.77,11.55,6.66,16.4a24.78,24.78,0,0,0-3.31,1.36c-26.76,10-46.86,16.25-62.75,19.82a148.23,148.23,0,0,1-30.48,4.05A25.45,25.45,0,0,1,560.23,319c-.42-8-.52-16.12-.56-24.17,1.47-35.58,4.62-78.56,11.91-111.21a78.86,78.86,0,0,1,3.64-12,35.39,35.39,0,0,1,9.08-13.46c.91-.85,1.84-1.71,2.77-2.54a214.37,214.37,0,0,1,32.11-23.82c32.72,16,42.44,31,61.84,31,14.53,0,20.5-12.08,20.5-25.19,0-7.86-3.46-16.53-8.47-24.88.51,0,1,0,1.52,0a24.51,24.51,0,0,0,14.13-4.06A35,35,0,0,1,726,124.47a120.52,120.52,0,0,1,9.8,24.21,53.53,53.53,0,0,0,7.11,15c6.05,9,9.91,19.32,9.91,29.76a39.7,39.7,0,0,1-3.5,16.65,55.77,55.77,0,0,0-5.22,23.19v1.13c0,10-.17,17.85-.46,24.35-.14,3.05-.31,5.82-.5,8.37q-.48,6.46-.37,12.95C741,279.58,739.15,279,737.05,278.49Z"
            />
            <path
              class={cls7}
              d="M752.14,283.35c-2.67-.91-5.66-2.05-9.39-3.22q-.12-6.48.37-12.95c.19-2.55.36-5.32.5-8.37a104.25,104.25,0,0,0,13.79,11.75Z"
            />
            <path
              class={cls6}
              d="M610.27,610.68A82.24,82.24,0,0,0,663.81,630q3.62,0,7.34-.33a119.61,119.61,0,0,0,27.71-6.08c24-8.09,48-22.75,65.54-37.54"
            />
            <path
              class={cls6}
              d="M602.35,372.88A96.38,96.38,0,0,0,653,386.79c36.42,0,75.62-19.41,102.56-44.37"
            />
            <path
              class={cls6}
              d="M693.05,112.77c5,8.35,8.47,17,8.47,24.88,0,13.11-6,25.19-20.5,25.19-19.4,0-29.12-15-61.84-31"
            />
            <path
              class={cls6}
              d="M604.89,258c8.69,11.19,16.35,22.44,18.78,37"
            />
            <path
              class={cls6}
              d="M616.53,339.07c-11.48,25.47-30.44,43.41-30.44,92.63,0,49.62,28,130.12,28,153.68,0,8.94-1.57,17-3.8,25.3-5.59,20.75-15.37,43.17-15.37,85.1,0,57.88,24.21,112.45,24.21,168.55a158.67,158.67,0,0,1-3.33,30.42q-.74,3.63-1.57,7.2a29.47,29.47,0,0,0,15.88,33.28,25.25,25.25,0,0,0,34.66-31.45c-.8-2.2-1.59-4.43-2.35-6.67-6.89-20.16-12-41.91-12-59.4,0-.1,14.43-176.05,14.43-176.14a241.93,241.93,0,0,1,6.36-31.88"
            />
            <path
              class={cls6}
              d="M615.78,894.75c5.24,10.13,13.52,18,23.05,18,7.27,0,17.76-6.71,23.56-15.65"
            />
            <path
              class={cls6}
              d="M698.39,802.37h0c2.62,6.84,7.13,12.17,10.71,19.89,8.81,19,13.36,37.54,26.9,50a16.64,16.64,0,0,0,21.75.74,73.25,73.25,0,0,0,6.46-5.93"
            />
            <path
              class={cls6}
              d="M698.86,623.61a216.75,216.75,0,0,0-4.69,46.56c0,29.38,7,74.65,7,109.31,0,.78,0,1.56,0,2.33a78.77,78.77,0,0,1-2.78,20.57c-.43,1.52-.9,3-1.43,4.5a42.68,42.68,0,0,0-2.32,14.69c0,12,3.11,23.27,3.11,36.67,0,3-.1,6-.19,9A9.91,9.91,0,0,0,701,868a7.4,7.4,0,0,0,1.41-.13c.44-8.16,1.82-17.16,5-24.5a101.25,101.25,0,0,0,8.23,23.93c9.32,16.36,27.2,26.14,45.55,26.14a47,47,0,0,0,14.42-2,7.06,7.06,0,0,0,4.56-4.18,6.79,6.79,0,0,0-2.58-8,64,64,0,0,1-13.34-12.15C748.65,848.41,742.1,821,740,795.88a140.53,140.53,0,0,1,1.15-32.72c5.34-35.42,16.21-107.82,23.3-177.1,3.92-38.42,6.68-75.9,6.68-105.58,0-46.66-4.3-93.87-15.55-138.06-.33-1.3-.67-2.59-1-3.88"
            />
            <path
              class={cls10}
              d="M744.76,301.26c-.72-4.11-1.24-8.26-1.58-12.42"
            />
            <path
              class={cls6}
              d="M742.75,280.13q-.12-6.48.37-12.95c.19-2.55.36-5.32.5-8.37.29-6.5.46-14.34.46-24.35v-1.13a55.77,55.77,0,0,1,5.22-23.19,39.7,39.7,0,0,0,3.5-16.65c0-10.44-3.86-20.75-9.91-29.76a53.53,53.53,0,0,1-7.11-15,120.52,120.52,0,0,0-9.8-24.21,35,35,0,0,0-17.28-15.73"
            />
            <path
              class={cls10}
              d="M682.59,317.89c7.88-2.66,16.19-1.71,24-4.51,6.45-2.31,10.36-8.59,16-12.29"
            />
            <path
              class={cls6}
              d="M682.38,131.79c1-6.65,2.52-13.07,4.08-19.63a61.14,61.14,0,0,0,6.59.61c.51,0,1,0,1.52,0a24.51,24.51,0,0,0,14.13-4.06c11.67-8,14.82-26.14,14.82-41.68,0-16.9-8.85-26.14-29-33.4-9,18.49-22.35,25.06-31.4,28.73H663c-7.65,0-12.38,4.19-12.38,8.66,0,3.1,2.29,6.34,7.47,8.39-1.87,8.92-3.64,19-8.23,31.05a17.53,17.53,0,0,1-8.82,9.5c-5.2,2.5-10,5-14.2,7.32q-3.89,2.2-7.69,4.52a214.37,214.37,0,0,0-32.11,23.82c-.93.83-1.86,1.69-2.77,2.54a35.39,35.39,0,0,0-9.08,13.46,78.86,78.86,0,0,0-3.64,12c-7.29,32.65-10.44,75.63-11.91,111.21,0,8,.14,16.12.56,24.17a25.45,25.45,0,0,0,25.82,24.1,148.23,148.23,0,0,0,30.48-4.05c15.89-3.57,36-9.8,62.75-19.82a24.78,24.78,0,0,1,3.31-1.36"
            />
            <path
              class={cls6}
              d="M610.07,204.28c-1,16.11-3.13,36.38-5.18,53.73-2.48,21-4.81,37.68-4.81,37.68l23.59-.69,55.19-1.61,2.92-.09s27.45-4.1,46.77-13.9a12.09,12.09,0,0,1,8.5-.91c2.1.54,4,1.09,5.7,1.64,3.73,1.17,6.72,2.31,9.39,3.22"
            />
            <path
              class={cls11}
              d="M749.71,289.24a44.3,44.3,0,0,1-6.53-.41,51.05,51.05,0,0,1-9.07-2c4.9,7.19,6,19.11,2.46,19s-4.58-10.46-9.65-14.87c1.47,5.07,4.57,17,.5,18a41.81,41.81,0,0,1-4.8-7.8c-1.64-3.18-3.12-6-4.52-6.74-2.61-1.31-10.29,7.52-10.29,7.52"
            />
            <path
              class={cls6}
              d="M678.86,293.39a11.62,11.62,0,0,0-2.93,8.1c0,5.41,2.77,11.55,6.66,16.4"
            />
            <path
              class={cls6}
              d="M784.79,297.53a55.65,55.65,0,0,1-7.93.85c-2.1,0-4.6-.22-4.6-1.25,0-2.86,18.26-6.22,29.92-10.93l2.11-4.67,19.58-43.37a2,2,0,0,0-2.57-2.61l-55,24a14.33,14.33,0,0,0-7.52,7.67l-1.38,3.34-5.27,12.79-2.43,5.89-5,12L725.7,347.49a2.93,2.93,0,0,0,4,3.73l24.79-12.68,26.7-13.64a14.44,14.44,0,0,0,6.61-6.93"
            />
            <path
              class={cls6}
              d="M779.5,314.22c2.8.9,5.87,1.66,8.62,2.26a77,77,0,0,0,8.51,1.46c8.87,0,13.32-13.38,13.32-21.52,0-6.75-2.09-10.33-5.66-14.89"
            />
            <path
              class={cls6}
              d="M784.79,297.53c-7.64,3.17-14.47,6.84-14.47,10.81a2,2,0,0,0,.22.89c.91,1.9,4.61,3.6,9,5"
            />
            <path
              class={cls6}
              d="M743.62,258.81a104.25,104.25,0,0,0,13.79,11.75"
            />
            <line
              class={cls12}
              x1="1151.7"
              y1="1028.57"
              x2="1151.7"
              y2="1028.57"
            />
            <line class={cls13} x1="1151.7" y1="1008" x2="1151.7" y2="894.89" />
            <line class={cls12} x1="1151.7" y1="884.6" x2="1151.7" y2="884.6" />
            <path
              class={cls8}
              d="M99.36,762.7c4.11,8.85-4.13,17.92-18.62,21.13V750.75C89.59,752.72,96.73,757,99.36,762.7Z"
            />
            <path
              class={cls7}
              d="M80.74,750.75v33.08c-1,.22-2,.41-3.07.57a52.13,52.13,0,0,1-19-.57V735.17c0,1.62,1.07,3.26,3.23,4.5a17.24,17.24,0,0,0,15.58,0c2.12-1.22,3.19-2.82,3.22-4.42Z"
            />
            <path
              class={cls7}
              d="M80.74,735.17v.08c0,1.6-1.1,3.2-3.22,4.42a17.24,17.24,0,0,1-15.58,0c-2.16-1.24-3.23-2.88-3.23-4.5s1.07-3.26,3.23-4.5a17.24,17.24,0,0,1,15.58,0C79.67,731.91,80.74,733.54,80.74,735.17Z"
            />
            <path
              class={cls8}
              d="M58.71,750.75v33.08c-8.84-2-16-6.27-18.62-12C36,763,44.23,754,58.71,750.75Z"
            />
            <path
              class={cls6}
              d="M80.74,750.75c8.85,2,16,6.27,18.62,12,4.11,8.85-4.13,17.92-18.62,21.13-1,.22-2,.41-3.07.57a52.13,52.13,0,0,1-19-.57c-8.84-2-16-6.27-18.62-12C36,763,44.23,754,58.71,750.75"
            />
            <path
              class={cls6}
              d="M80.74,735.25c0,1.6-1.1,3.2-3.22,4.42a17.24,17.24,0,0,1-15.58,0c-2.16-1.24-3.23-2.88-3.23-4.5s1.07-3.26,3.23-4.5a17.24,17.24,0,0,1,15.58,0c2.15,1.24,3.22,2.87,3.22,4.5"
            />
            <path class={cls6} d="M80.74,735.17v48.66" />
            <polyline
              class={cls6}
              points="58.71 783.83 58.71 750.75 58.71 735.17"
            />
            <path
              class={cls8}
              d="M1140.69,1101.53c-8.85-2-16-6.27-18.63-12-4.1-8.85,4.14-17.92,18.63-21.13Z"
            />
            <path
              class={cls7}
              d="M1159.64,1102.1a52.07,52.07,0,0,1-19-.57v-48.66c0,1.62,1.06,3.26,3.22,4.5a17.24,17.24,0,0,0,15.58,0c2.12-1.22,3.19-2.82,3.23-4.42v48.58C1161.72,1101.75,1160.69,1101.94,1159.64,1102.1Z"
            />
            <path
              class={cls8}
              d="M1162.72,1101.53v-33.08c8.84,2,16,6.27,18.61,12C1185.44,1089.25,1177.2,1098.32,1162.72,1101.53Z"
            />
            <path
              class={cls7}
              d="M1162.72,1052.87v.08c0,1.6-1.11,3.2-3.23,4.42a17.24,17.24,0,0,1-15.58,0c-2.16-1.24-3.22-2.88-3.22-4.5s1.06-3.26,3.22-4.5a17.24,17.24,0,0,1,15.58,0C1161.64,1049.61,1162.72,1051.24,1162.72,1052.87Z"
            />
            <path
              class={cls6}
              d="M1162.72,1068.45c8.84,2,16,6.27,18.61,12,4.11,8.85-4.13,17.92-18.61,21.13-1,.22-2,.41-3.08.57a52.07,52.07,0,0,1-19-.57c-8.85-2-16-6.27-18.63-12-4.1-8.85,4.14-17.92,18.63-21.13"
            />
            <path
              class={cls6}
              d="M1162.72,1053c0,1.6-1.11,3.2-3.23,4.42a17.24,17.24,0,0,1-15.58,0c-2.16-1.24-3.22-2.88-3.22-4.5s1.06-3.26,3.22-4.5a17.24,17.24,0,0,1,15.58,0c2.15,1.24,3.23,2.87,3.23,4.5"
            />
            <path class={cls6} d="M1162.72,1052.87v48.66" />
            <polyline
              class={cls6}
              points="1140.69 1101.53 1140.69 1068.45 1140.69 1052.87"
            />
            <path
              class={cls8}
              d="M1115.21,416.25v33.07c-8.84-2-16-6.26-18.62-11.95C1092.48,428.53,1100.72,419.46,1115.21,416.25Z"
            />
            <path
              class={cls7}
              d="M1137.25,400.74v48.58c-1,.22-2,.42-3.08.58a51.9,51.9,0,0,1-19-.58V400.67c0,1.62,1.07,3.26,3.22,4.5a17.24,17.24,0,0,0,15.58,0C1136.13,404,1137.21,402.35,1137.25,400.74Z"
            />
            <path
              class={cls8}
              d="M1137.25,416.25c8.83,2,16,6.27,18.61,11.95,4.1,8.85-4.14,17.92-18.61,21.12Z"
            />
            <path
              class={cls7}
              d="M1137.25,400.67v.07c0,1.61-1.12,3.21-3.24,4.43a17.24,17.24,0,0,1-15.58,0c-2.15-1.24-3.22-2.88-3.22-4.5s1.07-3.26,3.22-4.5a17.24,17.24,0,0,1,15.58,0C1136.17,397.41,1137.25,399,1137.25,400.67Z"
            />
            <path
              class={cls6}
              d="M1137.25,416.25c8.83,2,16,6.27,18.61,11.95,4.1,8.85-4.14,17.92-18.61,21.12-1,.22-2,.42-3.08.58a51.9,51.9,0,0,1-19-.58c-8.84-2-16-6.26-18.62-11.95-4.11-8.84,4.13-17.91,18.62-21.12"
            />
            <path
              class={cls6}
              d="M1137.25,400.74c0,1.61-1.12,3.21-3.24,4.43a17.24,17.24,0,0,1-15.58,0c-2.15-1.24-3.22-2.88-3.22-4.5s1.07-3.26,3.22-4.5a17.24,17.24,0,0,1,15.58,0c2.16,1.24,3.24,2.87,3.24,4.5"
            />
            <path class={cls6} d="M1137.25,400.67v48.65" />
            <polyline
              class={cls6}
              points="1115.21 449.32 1115.21 416.25 1115.21 400.67"
            />
            <line class={cls12} x1="69.73" y1="707.29" x2="69.73" y2="707.29" />
            <line class={cls14} x1="69.73" y1="686.66" x2="69.73" y2="573.22" />
            <line class={cls12} x1="69.73" y1="562.9" x2="69.73" y2="562.9" />
            <line
              class={cls12}
              x1="1126.23"
              y1="373.83"
              x2="1126.23"
              y2="373.83"
            />
            <line
              class={cls15}
              x1="1126.23"
              y1="351.97"
              x2="1126.23"
              y2="275.47"
            />
            <line
              class={cls12}
              x1="1126.23"
              y1="264.54"
              x2="1126.23"
              y2="264.54"
            />
            <polygon
              class={cls8}
              points="934.14 1010.88 934.14 1120.17 898.98 1140.46 898.98 1031.18 934.14 1010.88"
            />
            <polygon
              class={cls7}
              points="934.14 1010.88 898.98 1031.18 863.81 1010.88 898.98 990.58 934.14 1010.88"
            />
            <polygon
              class={cls7}
              points="898.98 1031.18 898.98 1140.46 871.4 1124.55 871.4 1097.34 871.4 1088.58 871.4 1068.81 863.81 1064.43 863.81 1010.88 898.98 1031.18"
            />
            <polygon
              class={cls8}
              points="871.4 1124.55 871.4 1156.38 836.24 1176.68 836.24 1089.11 871.4 1068.81 871.4 1088.58 871.4 1097.34 871.4 1124.55"
            />
            <polygon
              class={cls7}
              points="871.4 1068.81 836.24 1089.11 801.08 1068.81 836.24 1048.51 863.81 1064.43 871.4 1068.81"
            />
            <polygon
              class={cls7}
              points="836.24 1089.11 836.24 1176.68 808.66 1160.76 808.66 1141.44 801.08 1137.06 801.08 1068.81 836.24 1089.11"
            />
            <polygon
              class={cls8}
              points="808.66 1160.76 808.66 1192.6 773.5 1212.91 773.5 1161.74 808.66 1141.44 808.66 1160.76"
            />
            <polygon
              class={cls7}
              points="808.66 1141.44 773.5 1161.74 738.34 1141.44 773.5 1121.14 801.08 1137.06 808.66 1141.44"
            />
            <polygon
              class={cls7}
              points="773.5 1161.74 773.5 1212.91 738.34 1192.6 738.34 1141.44 773.5 1161.74"
            />
            <polygon
              class={cls6}
              points="863.81 1010.88 898.98 1031.18 934.14 1010.88 898.98 990.58 863.81 1010.88"
            />
            <line
              class={cls6}
              x1="898.98"
              y1="1031.18"
              x2="898.98"
              y2="1140.46"
            />
            <polyline
              class={cls6}
              points="934.14 1010.88 934.14 1120.17 898.98 1140.46 871.4 1124.55"
            />
            <polygon
              class={cls6}
              points="871.4 1068.81 863.81 1064.43 836.24 1048.51 801.08 1068.81 836.24 1089.11 871.4 1068.81"
            />
            <line
              class={cls6}
              x1="836.24"
              y1="1089.11"
              x2="836.24"
              y2="1176.68"
            />
            <polyline
              class={cls6}
              points="871.4 1068.81 871.4 1088.58 871.4 1097.34 871.4 1124.55 871.4 1156.38 836.24 1176.68 808.66 1160.76"
            />
            <line
              class={cls6}
              x1="801.08"
              y1="1137.06"
              x2="801.08"
              y2="1068.81"
            />
            <polygon
              class={cls6}
              points="808.66 1141.44 801.08 1137.06 773.5 1121.14 738.34 1141.44 773.5 1161.74 808.66 1141.44"
            />
            <line
              class={cls6}
              x1="773.5"
              y1="1161.74"
              x2="773.5"
              y2="1212.91"
            />
            <polyline
              class={cls6}
              points="808.66 1141.44 808.66 1160.76 808.66 1192.6 773.5 1212.91 738.34 1192.6 738.34 1141.44"
            />
            <line
              class={cls6}
              x1="863.81"
              y1="1010.89"
              x2="863.81"
              y2="1064.43"
            />
            <polyline
              class={cls6}
              points="650.14 1077.81 631.92 1095.77 613.7 1056.77 595.48 1074.72 577.25 1035.73 559.03 1053.68"
            />
            <polyline
              class={cls6}
              points="1246.6 539.66 1264.82 557.61 1283.04 518.62 1301.26 536.57 1319.48 497.58 1337.71 515.53"
            />
            <line class={cls6} x1="1009" y1="934.51" x2="1033.98" y2="920.09" />
            <line class={cls6} x1="1033.98" y1="934.51" x2="1009" y2="920.09" />
            <line
              class={cls6}
              x1="190.55"
              y1="193.16"
              x2="215.52"
              y2="178.75"
            />
            <line
              class={cls6}
              x1="215.52"
              y1="193.16"
              x2="190.55"
              y2="178.75"
            />
            <path
              class={cls16}
              d="M214.82,663.91c18.85-36,49.38-53.78,68.35-39.82"
            />
            <path
              class={cls16}
              d="M266.73,654.18C256.85,647,241,656.24,231.22,675"
            />
            <path
              class={cls16}
              d="M198.34,652.49c28-53.42,73.23-79.7,101.31-58.89"
            />
            <path
              class={cls17}
              d="M257.36,687c0-5.34-3.75-7.51-8.38-4.84s-8.39,9.18-8.39,14.53,3.76,7.51,8.39,4.84S257.36,692.35,257.36,687Z"
            />
            <path
              class={cls16}
              d="M1380.55,743.16c-18.86-36-49.38-53.79-68.35-39.83"
            />
            <path
              class={cls16}
              d="M1328.63,733.42c9.88-7.17,25.72,2.07,35.51,20.78"
            />
            <path
              class={cls16}
              d="M1397,731.74c-28-53.43-73.23-79.71-101.31-58.9"
            />
            <path
              class={cls17}
              d="M1338,766.24c0-5.34,3.76-7.51,8.39-4.84s8.38,9.18,8.38,14.53-3.75,7.51-8.38,4.84S1338,771.59,1338,766.24Z"
            />
            <path
              class={cls16}
              d="M972.87,295.68c-18.85-36-49.38-53.78-68.35-39.82"
            />
            <path class={cls16} d="M921,286c9.87-7.18,25.71,2.06,35.5,20.78" />
            <path
              class={cls16}
              d="M989.34,284.26c-28-53.42-73.23-79.7-101.31-58.89"
            />
            <ellipse
              class={cls17}
              cx="938.71"
              cy="323.61"
              rx="6.85"
              ry="11.86"
              transform="translate(-36.04 512.72) rotate(-30)"
            />
            <path
              class={cls18}
              d="M1295.9,357.86a14.75,14.75,0,1,0-14.75,14.75A14.75,14.75,0,0,0,1295.9,357.86Z"
            />
            <path
              class={cls18}
              d="M1285.07,915.82a14.75,14.75,0,1,0-14.75,14.75A14.75,14.75,0,0,0,1285.07,915.82Z"
            />
            <path
              class={cls18}
              d="M860.59,747.51a14.76,14.76,0,1,0-14.76,14.75A14.75,14.75,0,0,0,860.59,747.51Z"
            />
            <path
              class={cls18}
              d="M429.14,1055.2A14.76,14.76,0,1,0,414.38,1070,14.76,14.76,0,0,0,429.14,1055.2Z"
            />
            <path
              class={cls18}
              d="M500.7,545.9a14.76,14.76,0,1,0-14.76,14.76A14.76,14.76,0,0,0,500.7,545.9Z"
            />
            <path
              class={cls19}
              d="M1189.14,774.57l-20.94-9.88-20.93,34v42.82l41.87-24.17Zm38.37-5.09c0,19.88-7,41.86-18.25,61.38s-26.82,36.54-44,46.47-32.76,10.89-44,4.38S1103,861.26,1103,841.39c0-19.55,6.75-41.17,17.7-60.46,11.31-19.89,27.1-37.32,44.56-47.4,17.19-9.91,32.76-10.85,44-4.33S1227.5,749.64,1227.51,769.48Z"
            />
            <path
              class={cls8}
              d="M1209.26,729.18v0c-11.26-6.52-26.83-5.58-44,4.33-17.46,10.08-33.25,27.51-44.56,47.4-11,19.29-17.71,40.91-17.7,60.46,0,19.87,7,33.81,18.24,40.32l-18-10.4C1091.93,864.8,1085,850.84,1085,831c0-19.53,6.74-41.16,17.7-60.45,11.3-19.89,27.1-37.3,44.56-47.39,17.19-9.93,32.77-10.87,44-4.35Z"
            />
            <path
              class={cls7}
              d="M1189.14,774.57v42.82l-41.87,24.17V798.74l20.93-34Zm-14.91,34V792.67l-12,7v15.92Z"
            />
            <polygon
              class={cls7}
              points="1174.23 792.67 1174.23 808.58 1162.18 815.54 1162.18 799.63 1174.23 792.67"
            />
            <path
              class={cls6}
              d="M1209.25,729.2c-11.26-6.52-26.83-5.58-44,4.33-17.46,10.08-33.25,27.51-44.56,47.4-11,19.29-17.71,40.91-17.7,60.46,0,19.87,7,33.81,18.24,40.32s26.84,5.55,44-4.38,32.77-27,44-46.47,18.25-41.5,18.25-61.38S1220.53,735.69,1209.25,729.2Z"
            />
            <path
              class={cls6}
              d="M1209.26,729.18l-18-10.39c-11.26-6.52-26.84-5.58-44,4.35-17.46,10.09-33.26,27.5-44.56,47.39-11,19.29-17.72,40.92-17.7,60.45,0,19.86,7,33.82,18.23,40.33l18,10.4"
            />
            <polyline
              class={cls6}
              points="1189.14 774.57 1189.14 817.39 1147.27 841.56 1147.27 798.74"
            />
            <polyline
              class={cls6}
              points="1135.27 818.25 1147.27 798.74 1168.2 764.69 1189.14 774.57 1201.13 780.22"
            />
            <polygon
              class={cls6}
              points="1174.23 808.58 1162.18 815.54 1162.18 799.63 1174.23 792.67 1174.23 808.58"
            />
            <path
              class={cls19}
              d="M145.53,466.55c0,19.87-7,41.85-18.24,61.37s-26.82,36.54-44,46.47-32.77,10.88-44,4.38S21,558.31,21,538.45c0-19.56,6.74-41.17,17.7-60.45C50,458.11,65.8,440.67,83.26,430.59c17.19-9.91,32.76-10.85,44-4.32S145.52,446.69,145.53,466.55ZM109,497.13c0-7.58-2.11-12.61-7-15.31-.1,9.59-10.6,14.37-8.89,7S98,462.84,82.21,464.7c4.59,10.8-8.63,25.53-14.34,38.15-3.22,7.09-5.93,14.53-5.93,21.45,0,15,10.53,21.11,23.54,13.6S109,512.14,109,497.13Z"
            />
            <path
              class={cls8}
              d="M127.29,426.24v0c-11.26-6.53-26.83-5.59-44,4.32C65.8,440.67,50,458.11,38.7,478c-11,19.28-17.7,40.89-17.7,60.45,0,19.86,7,33.81,18.24,40.32l-18-10.41C10,561.86,3,547.9,3,528.05c0-19.54,6.74-41.18,17.7-60.45C32,447.7,47.8,430.29,65.25,420.2c17.2-9.93,32.78-10.87,44-4.35Z"
            />
            <path
              class={cls7}
              d="M102,481.82c4.91,2.7,7,7.73,7,15.31,0,15-10.54,33.26-23.54,40.77s-23.54,1.42-23.54-13.6c0-6.92,2.71-14.36,5.93-21.45,5.71-12.62,18.93-27.35,14.34-38.15,15.83-1.86,12.61,16.67,10.9,24.08S101.9,491.41,102,481.82Z"
            />
            <path
              class={cls6}
              d="M127.28,426.27c-11.26-6.53-26.83-5.59-44,4.32C65.8,440.67,50,458.11,38.7,478c-11,19.28-17.7,40.89-17.7,60.45,0,19.86,7,33.81,18.24,40.32s26.83,5.54,44-4.38,32.76-27,44-46.47,18.24-41.5,18.24-61.37S138.55,432.75,127.28,426.27Z"
            />
            <path
              class={cls6}
              d="M127.29,426.24l-18-10.39c-11.25-6.52-26.83-5.58-44,4.35C47.8,430.29,32,447.7,20.7,467.6,9.74,486.87,3,508.51,3,528.05c0,19.85,7,33.81,18.23,40.31l18,10.41"
            />
            <path
              class={cls6}
              d="M102,481.82c4.91,2.7,7,7.73,7,15.31,0,15-10.54,33.26-23.54,40.77s-23.54,1.42-23.54-13.6c0-6.92,2.71-14.36,5.93-21.45,5.71-12.62,18.93-27.35,14.34-38.15,15.83-1.86,12.61,16.67,10.9,24.08S101.9,491.41,102,481.82Z"
            />
            <path
              class={cls7}
              d="M1193,201.53c0,19.87-7,33.82-18.23,40.33l-18,10.4c11.28-6.5,18.24-20.45,18.23-40.32,0-19.55-6.74-41.17-17.69-60.45-11.32-19.89-27.11-37.32-44.57-47.4-17.19-9.92-32.75-10.86-44-4.33l0,0,18-10.39c11.26-6.52,26.84-5.59,44,4.35,17.46,10.08,33.26,27.49,44.55,47.38C1186.22,160.37,1193,182,1193,201.53Z"
            />
            <path
              class={cls19}
              d="M1175,211.94c0,19.87-7,33.82-18.23,40.32s-26.84,5.55-44-4.38-32.76-27-44-46.47-18.24-41.5-18.24-61.37,7-33.8,18.26-40.28,26.82-5.59,44,4.33c17.46,10.08,33.25,27.51,44.57,47.4C1168.21,170.77,1175,192.39,1175,211.94Zm-38.74-15.86a18.07,18.07,0,0,0,.24-3c0-8.18-5-17.68-11.11-21.22a12.46,12.46,0,0,0-1.21-.61c-.85-9.6-6.67-20-13.74-24.08a12.27,12.27,0,0,0-4.13-1.55,7.29,7.29,0,0,0-5.36,1.07l-.14.1c-2.61,1.85-4.23,5.63-4.23,10.85,0,.58,0,1.17,0,1.76,0,0,0,.09,0,.14h0c-5-2.54-9,.69-9,7.47,0,7,4.25,15.15,9.51,18.18l28.24,16.3a10.52,10.52,0,0,0,1.1.57,8.3,8.3,0,0,0,3.1.77,5.62,5.62,0,0,0,3.51-1l.07,0A8.66,8.66,0,0,0,1136.21,196.08Z"
            />
            <path
              class={cls7}
              d="M1136.45,193.13a18.07,18.07,0,0,1-.24,3,8.66,8.66,0,0,1-3.09,5.71l-.07,0a5.62,5.62,0,0,1-3.51,1,8.3,8.3,0,0,1-3.1-.77,10.52,10.52,0,0,1-1.1-.57l-28.24-16.3c-5.26-3-9.51-11.17-9.51-18.18,0-6.78,4-10,9-7.47h0c0-.05,0-.1,0-.14,0-.59,0-1.18,0-1.76,0-5.22,1.62-9,4.23-10.85l.14-.1a7.29,7.29,0,0,1,5.36-1.07,12.27,12.27,0,0,1,4.13,1.55c7.07,4.08,12.89,14.48,13.74,24.08a12.46,12.46,0,0,1,1.21.61C1131.48,175.45,1136.45,185,1136.45,193.13Z"
            />
            <path
              class={cls6}
              d="M1068.68,99.76c11.26-6.53,26.82-5.59,44,4.33,17.46,10.08,33.25,27.51,44.57,47.4,11,19.28,17.7,40.9,17.69,60.45,0,19.87-7,33.82-18.23,40.32s-26.84,5.55-44-4.38-32.76-27-44-46.47-18.24-41.5-18.24-61.37S1057.4,106.24,1068.68,99.76Z"
            />
            <path
              class={cls6}
              d="M1068.66,99.74l18-10.39c11.26-6.52,26.84-5.59,44,4.35,17.46,10.08,33.26,27.49,44.55,47.38,11,19.29,17.73,40.93,17.71,60.45,0,19.87-7,33.82-18.23,40.33l-18,10.4"
            />
            <path
              class={cls6}
              d="M1100.9,146.74l-.14.1c-2.61,1.85-4.23,5.63-4.23,10.85,0,.58,0,1.17,0,1.76,0,0,0,.09,0,.14h0c-5-2.54-9,.69-9,7.47,0,7,4.25,15.15,9.51,18.18l28.24,16.3a10.52,10.52,0,0,0,1.1.57,8.3,8.3,0,0,0,3.1.77,5.62,5.62,0,0,0,3.51-1l.07,0a8.66,8.66,0,0,0,3.09-5.71,18.07,18.07,0,0,0,.24-3c0-8.18-5-17.68-11.11-21.22a12.46,12.46,0,0,0-1.21-.61c-.85-9.6-6.67-20-13.74-24.08a12.27,12.27,0,0,0-4.13-1.55A7.29,7.29,0,0,0,1100.9,146.74Z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
